import { ITopProductProps } from '../../../../../../topProduct.models';
import * as S from '../../topNavigationLiteHero.style';
import { CustomText } from '@vfit/shared/atoms';
import TopNavigationLitePopupTagging from './topNavigationLitePopup.tagging';

export const TopNavigationLitePopup = ({ product }: ITopProductProps) => {
  const { pdpLitePopupDescription, pdpLitePopupTitle } = product;
  return (
    <>
      <TopNavigationLitePopupTagging product={product} />
      <S.ModalTitle>
        <CustomText
          size={36}
          lineHeight={45}
          textAlign="left"
          text={pdpLitePopupTitle || ''}
          fontFamily={'VodafoneExB'}
        />
      </S.ModalTitle>

      <S.ModalContent>
        <CustomText
          size={18}
          lineHeight={24}
          textAlign="left"
          text={pdpLitePopupDescription || ''}
        />
      </S.ModalContent>
    </>
  );
};

